<template>
    <div>
        <h1 class="text-center">Signature Required - Primary Seller</h1>
        <b-row>
            <b-col cols="12" lg="12" class="d-flex justify-content-center">
                <b-img :src="require('@assets/images/v3/Warning.svg')"/>
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col>
                <p class="text-center">It looks like <strong>{{fullName}}</strong> has made edits. Once <strong>{{ fullName }}</strong> re-signs the disclosure, you will get a new invitation to sign.</p>
                <br />
                <p class="text-center">Questions - contact support <a href="mailto:customersuccess@sellersshield.com">customersuccess@sellersshield.com</a></p>
            </b-col>
        </b-row>
        <b-form-row class="justify-content-center">
            <b-col cols="auto">
                <b-button
                    class="gold-button"
                    size="lg"
                    @click="$emit('refresh')"
                >
                    Refresh
                </b-button>
            </b-col>
        </b-form-row>
    </div>
</template>

<script>
import DisclosureAppResource from '@sellers-shield-home-protection/ss-core-js/src/AppResources/DisclosureAppResource';
import OrderAppResource from '@sellers-shield-home-protection/ss-core-js/src/AppResources/DisclosureAppResource';
import SellerAppResource from '@sellers-shield-home-protection/ss-core-js/src/AppResources/SellerAppResource';
export default {
    name: 'PrimaryNeedsSignature',
    props:{
        disclosureAppResource: {
            type: DisclosureAppResource
        },
        orderAppResource: {
            type: OrderAppResource
        },
        primarySeller: {
            type: SellerAppResource
        }
    },
    data:()=>({

    }),
    computed:{
        fullName(){
            return this.primarySeller ? this.primarySeller.firstName : '';
        }
    },
    methods:{

    }
}
</script>
